/**
 * Redux reducer for the backgroundPhotos key within the boards reducer
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import produce from 'immer'
import {
  UPDATE_BACKGROUND_PHOTO,
  DELETE_PHOTOS
} from 'client/app/js/services/boards/types'

export default produce((draft, action) => {
  const { bid } = action.data?.result ?? {}
  const { boards } = action.data?.entities ?? {}

  switch (action.type) {
    // Replace the backgroundPhotos attribute with the returned result
    case UPDATE_BACKGROUND_PHOTO:
    case DELETE_PHOTOS:
      draft[bid].backgroundPhotos = boards[bid].backgroundPhotos
      break
    default:
  }
})
